module.exports = __webpack_public_path__ + "static/media/BAND-BNB.85cc63dd.svg";